import { render, staticRenderFns } from "./KbitemEdit.vue?vue&type=template&id=5dbfa802&"
import script from "./KbitemEdit.vue?vue&type=script&lang=js&"
export * from "./KbitemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports